import React, { useCallback } from 'react';
import StripePaymentButtonElement from '../../../../../01_atoms/Payments/StripePaymentButtonElement';
import { useForm, useFormState } from 'react-final-form';
import { RG, SD } from '../../../../../../utils/constants';
import PropTypes from 'prop-types';
import unexpectedErrorMessage from '../../../../../../utils/unexpectedErrorMessage';

import styles from './index.module.scss';

const StripePaymentButton = ({
  orderId = null,
  paymentMethodId,
  showButton = true,
  onStripeButtonAvailabilityCheck,
  onSuccessPayment,
  onStripeButtonClick,
  onCancelPayment,
  onError,
  beforePaymentMethod,
}) => {
  const form = useForm();
  const formState = useFormState();
  const donationType = formState.values['donation_type'];
  const totalAmount = formState.values.totalAmount ?? 0;
  const amount = formState.values.fundraisingCostsApplied
    ? totalAmount
    : parseInt(formState.values.amount[donationType] || 0, 10);

  const handleError = useCallback((error) => {
    onError({
      paymentMethodId,
      message: "Sorry, we couldn't complete the donation. Please try a different payment method.",
      subline: unexpectedErrorMessage(),
      additionalMessage: error.message,
    });
  });

  return (
    <div className={styles['stripe-payment-button']}>
      <StripePaymentButtonElement
        amount={amount}
        orderId={orderId}
        donationType={donationType === 'single' ? SD : RG}
        paymentMethodId={paymentMethodId}
        showButton={showButton}
        onSubmitDonation={() => form.submit()}
        onUnexpectedError={handleError}
        onSuccessPaymentCompleted={onSuccessPayment}
        beforePaymentMethod={beforePaymentMethod}
        onCancelPayment={onCancelPayment}
        onStripeButtonClick={onStripeButtonClick}
        onConfirmCardPaymentError={handleError}
        onStripeButtonAvailabilityCheck={onStripeButtonAvailabilityCheck}
        onConfirmCardPaymentActionError={handleError}
        buttonStyles={{
          paymentRequestButton: {
            type: 'donate',
            height: '50px',
          },
        }}
      />
    </div>
  );
};

StripePaymentButton.propTypes = {
  orderId: PropTypes.number,
  paymentMethodId: PropTypes.string.isRequired,
  showButton: PropTypes.bool,
  onStripeButtonAvailabilityCheck: PropTypes.func.isRequired,
  onSuccessPayment: PropTypes.func.isRequired,
  onStripeButtonClick: PropTypes.func.isRequired,
  onCancelPayment: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  beforePaymentMethod: PropTypes.func.isRequired,
};

export default StripePaymentButton;
